'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBodyClassname = require('react-body-classname');

var _reactBodyClassname2 = _interopRequireDefault(_reactBodyClassname);

var _reactRedux = require('react-redux');

var _reduxRouter = require('redux-router');

var _components = require('../components');

var _eventDetail = require('redux/modules/eventDetail');

var _connectData = require('helpers/connectData');

var _connectData2 = _interopRequireDefault(_connectData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchData(getState, dispatch, location, params) {
  if (!(0, _eventDetail.isLoaded)(getState())) {
    return dispatch((0, _eventDetail.show)(params.id));
  }
}

var EventPageContainer = (_dec = (0, _connectData2.default)(fetchData), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    event: state.eventDetail.data,
    error: state.eventDetail.error,
    location: state.router.location
  };
}, { push: _reduxRouter.push, show: _eventDetail.show }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(EventPageContainer, _Component);

  function EventPageContainer() {
    (0, _classCallCheck3.default)(this, EventPageContainer);
    return (0, _possibleConstructorReturn3.default)(this, (EventPageContainer.__proto__ || (0, _getPrototypeOf2.default)(EventPageContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(EventPageContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.event) {
        this.props.setPageTitle(this.props.event.title);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.error) {
        switch (this.props.error.status_code) {
          case 404:
          default:
            return _react2.default.createElement(_components.NotFound, null);
        }
      }

      return _react2.default.createElement(
        _reactBodyClassname2.default,
        { className: 'event' },
        _react2.default.createElement(_components.EventPage, this.props)
      );
    }
  }]);
  return EventPageContainer;
}(_react.Component), _class2.propTypes = {
  params: _react.PropTypes.object.isRequired,
  error: _react.PropTypes.any,
  event: _react.PropTypes.object,
  location: _react.PropTypes.any,
  push: _react.PropTypes.func.isRequired,
  setPageTitle: _react.PropTypes.func.isRequired
}, _temp)) || _class) || _class);
exports.default = EventPageContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/EventPageContainer.js
// module id = 1128
// module chunks = 0